import { useTheme } from 'styled-components';

export const useIsNarrowViewport = (): boolean => useTheme().mqMatch('xl');
